import React, { FC, PropsWithChildren, ReactNode } from 'react';

import MuiIcon from '../../../MuiIcon';
import { MuiIconName } from '../../../MuiIcon/types';

import * as Styled from './styled';

export type Props = PropsWithChildren & {
  heading: ReactNode;
  icon: MuiIconName;
  isEmpty: boolean;
};
/**
 * Input for the compose section popup
 * (assignees, dateDue)
 *
 * @param props          Props passed to the component
 * @param props.children Section contents
 * @param props.heading  What to render as the section heading (usually just a heading string)
 * @param props.icon     Icon to show in the section
 * @param props.isEmpty  Whether the section has some content or not
 * @returns              The component itself
 */
const ComposeMetaSection: FC<Props> = ({
  children,
  heading,
  icon,
  isEmpty,
}) => {
  return (
    <Styled.Wrapper as="section">
      <Styled.IconWrapper>
        <MuiIcon color="primary" fontSize="small" icon={icon} />
      </Styled.IconWrapper>
      <Styled.Content data-is-empty={isEmpty}>
        {isEmpty ? (
          <Styled.Heading as="h2" color="primary">
            {heading}
          </Styled.Heading>
        ) : (
          <>
            {children}
            <MuiIcon color="primary" fontSize="small" icon="edit" />
          </>
        )}
      </Styled.Content>
    </Styled.Wrapper>
  );
};

export default ComposeMetaSection;
